import React, { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

import { Link, useNavigate } from "react-router-dom";
import "./SideDrawer.css";
import FootprintSvg from "../../../assets/Footprints_Logo-White.svg";
import { slide as Menu } from "react-burger-menu";
import className from "classnames";
import { useLocation } from "react-router-dom";
import manifest from "../../../manifest.json";

import { useAtom } from "jotai";
import { auth_token, alertModal, sidebar } from "../../../AtomStore/store";
import {
  StyledContainer,
  StyledIcon,
  StyledIcon2,
  StyledList,
  StyledNavbar,
  StyledSPan2,
  StyledSPan3,
  StyledSPan4,
} from "./styles";
import { StyledSpan } from "../Header/styles";
import { App } from "@capacitor/app";

export const draweItems = [
  {
    name: "Home",
    icon: "icon-home",
    path: "blogs",
    // component: Blogs,
  },

  {
    name: "Child Timeline",
    icon: "icon-timeline",
    path: "timeline",
    // component: ChildTimeline,
  },
  {
    name: "My Profile",
    icon: "icon-user",
    path: "myProfile",
    // component: MyProfile,
  },
  {
    name: "Attendance",
    icon: "icon-holiday-calender",
    path: "attendance",
    // component: MyProfile,
  },

  {
    name: "My Center",
    icon: "icon-admission",
    // component: MyCenter,
    path: "center",
  },
  {
    name: "Live CCTV",
    icon: "icon-video",
    // component: Cctv,
    path: "cctv",
  },
  {
    name: "Conversation",
    icon: "icon-chat",
    // component: Conversation,
    path: "chat",
  },
  {
    name: "Activity Calendar",
    icon: "icon-holiday-calender",
    // component: ActivityCalendar,
    path: "activityCalendar",
  },
  {
    name: "Food Menu",
    icon: "icon-meal",
    // component: FoodMenu,
    path: "foodMenu",
  },
  {
    name: "Growth",
    icon: "icon-growth",
    // component: Growth,
    path: "growth",
  },
  {
    name: "News Room",
    icon: "icon-newspaper",
    // component: News,
    path: "newsRoom",
  },
  {
    name: "Outdoor Activity",
    icon: "icon-outdoor-activity",
    // component: OutdoorActivity,
    path: "outdoorActivity",
  },
  {
    name: "Photo Gallery",
    icon: "icon-photo-gallery-2",
    // component: PhotoGallery,
    path: "photoGallery",
  },
  {
    name: "Parent Orientation Videos",
    icon: "icon-video-group-icon-2",
    // component: ParentVideos,
    path: "parentVideo",
  },

  {
    name: "Holiday Calendar",
    icon: "icon-calender",
    // component: Holidays,
    path: "holidayCalendar",
  },
  {
    name: "Support",
    // component: Support,
    icon: "icon-support",
    path: "support",
  },
];
const SideMenu = () => {
  const [, setActive] = useState(0);
  const [collapse, setCollapse] = useAtom(sidebar);
  const [, setToken] = useAtom(auth_token);
  const [modal, setModal] = useAtom(alertModal);
  const location = useLocation();
  const navigate = useNavigate();
  // useEffect(() => {
  //   // Retrieve active tab index from localStorage
  //   const storedActiveTab = localStorage.getItem("activeTab");
  //   if (storedActiveTab !== null) {
  //     setActive(parseInt(storedActiveTab));
  //   }
  // }, []);

  useEffect(() => {
    // Restore active tab
    const storedActiveTab = localStorage.getItem("activeTab");
    if (storedActiveTab !== null) {
      setActive(parseInt(storedActiveTab));
    }

    // Back button handler to close sidebar only
    const handleBackButton = async () => {
      if (collapse) {
        document.body.style.overflow = "";
        setCollapse(false);
      }

      if (location.pathname === "/blogs" || location.pathname === "/login") {
        await App.exitApp();
      } else {
        window.history.back();
      }
    };
    // Disable scroll when sidebar is open
    document.body.style.overflow = collapse ? "hidden" : "";

    let listener;

    // Register listener
    App.addListener("backButton", handleBackButton).then((result) => {
      listener = result;
    });

    return () => {
      if (listener) {
        listener.remove();
        document.body.style.overflow = "";
      }
    };
  }, [collapse]);

  const handleTabClick = (index) => {
    // Update active tab index and store it in localStorage
    setActive(index);
    setCollapse(false);
    localStorage.setItem("activeTab", index);
    document.body.style.overflow = "";
  };

  const { innerWidth: width } = window;
  // const logo = {
  //   imgAlt: "Footprints-Logo",
  //   imgSrc: require("../../../assets/Footprints-Logo.svg"),
  // };
  const Menulogo = {
    imgAlt: "Footprints-Logo",
    imgSrc: require("../../../assets/Footprints_Logo-White.svg"),
  };

  return (
    <>
      {" "}
      {collapse && (
        <div
          className="sidebar-overlay"
          onClick={() => {
            document.body.style.overflow = "";
            setCollapse(false);
          }}
        ></div>
      )}
      <StyledNavbar
        className="navbar-vertical fixed-left navbar-light "
        expand="md"
        id="sidenav-main"
      >
        <StyledContainer
          fluid
          className="navbar-vertical flex-nowrap  navbar-light fixed-left mobile-fixes "
          expand="md"
          id="sidenav-main"
        >
          <Menu
            isOpen={collapse}
            onStateChange={(state) => {
              setCollapse(state.isOpen);
              document.body.style.overflow = state.isOpen ? "hidden" : "";
            }}
            width={"270px"}
          >
            <div
              className="sideMenu"
              style={{
                overflowY: "scroll",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE 10+
                scrollBehavior: "smooth", // Smooth scroll
              }}
            >
              <div className="sideMenu-header d-md-none">
                {Menulogo ? (
                  <img
                    alt={Menulogo.imgAlt}
                    src={FootprintSvg}
                    style={{ fill: "white !important" }}
                  />
                ) : null}
              </div>
              <div className="sidemenu-content" hidden={width > 768 && false}>
                {draweItems.map((item, index) => (
                  <StyledList key={index}>
                    {
                      <Link
                        key={index}
                        to={`/${item.path}`}
                        onClick={() => handleTabClick(index)}
                        className={className({
                          "nav-link": true,
                          active:
                            location.pathname.toLowerCase() ===
                            `/${item.path.toLowerCase()}`,
                        })}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {typeof item.icon === "string" && (
                          <StyledIcon icon={item.icon} />
                        )}
                        {typeof item.icon === "object" && (
                          <StyledSpan>{item.icon}</StyledSpan>
                        )}
                        <StyledSPan2>{item.name}</StyledSPan2>
                      </Link>
                    }
                  </StyledList>
                ))}
                <StyledList key="">
                  {
                    <Link
                      key=""
                      onClick={() => {
                        setCollapse(false);
                        setModal({
                          ...modal,
                          state: true,
                          type: "Success",
                          isConfirm: true,
                          message: "Are You Sure You Want To Logout ?",
                          onOkPressed: async () => {
                            setToken("");

                            await App.removeAllListeners();
                            navigate("/login");
                          },
                          onCancelPressed: () => {},
                        });
                      }}
                      className="nav-link"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <StyledIcon2 />

                      <StyledSPan2>Logout</StyledSPan2>
                    </Link>
                  }
                </StyledList>
                {/* <li key="Logout" className="nav-item  ">
                  {
                    <StyledSPan3
                      onClick={() => {
                        setModal({
                          ...modal,
                          state: true,
                          type: 'Success',
                          isConfirm: true,
                          message: 'Are You Sure You Want To Logout ?',
                          onOkPressed: async () => {
                            setToken('');
                            setCollapse(false);
                            await App.removeAllListeners();
                            navigate('/login');
                          },
                          onCancelPressed: () => {},
                        });
                      }}
                      className="nav-link"
                    >
                      <StyledIcon2 />
                      <StyledSPan4>Logout</StyledSPan4>
                    </StyledSPan3>
                  }
                </li> */}
              </div>
              {/* <div className="flex  mt-4 mb-4 ">
                <button
                  onClick={() => {
                    setCollapse(false);
                    setModal({
                      ...modal,
                      state: true,
                      type: "Success",
                      isConfirm: true,
                      message: "Are You Sure You Want To Logout ?",
                      onOkPressed: async () => {
                        setToken("");

                        await App.removeAllListeners();
                        navigate("/login");
                      },
                      onCancelPressed: () => {},
                    });
                  }}
                  className="bg-red mx-4 h-10 text-center rounded-full text-white w-full font-semibold"
                >
                  <span></span> <StyledIcon2 /> Logout
                </button>
              </div> */}
              <div className="text-center lg:border-t text-white">
                <h6
                  className="text-white font-medium pt-2 pb-4"
                  style={{ fontSize: 14 }}
                >{`${manifest.applicationName} v${manifest.version}`}</h6>
              </div>
            </div>
          </Menu>
        </StyledContainer>
      </StyledNavbar>
    </>
  );
};

export default SideMenu;
